import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'global'),
  es: flattenMessages(es, 'global'),
  ru: flattenMessages(ru, 'global'),
  zh: flattenMessages(zh, 'global'),
};
